/* tslint:disable */
/* eslint-disable */
/**
 * Relays-Online
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AddOrUpdateShoppingCartItemsCommand,
    AddOrUpdateShoppingCartItemsCommandFromJSON,
    AddOrUpdateShoppingCartItemsCommandToJSON,
    ApproveQuoteCommand,
    ApproveQuoteCommandFromJSON,
    ApproveQuoteCommandToJSON,
    AttachmentCreatedDto,
    AttachmentCreatedDtoFromJSON,
    AttachmentCreatedDtoToJSON,
    CreateQuoteDto,
    CreateQuoteDtoFromJSON,
    CreateQuoteDtoToJSON,
    CreateShoppingCartCommand,
    CreateShoppingCartCommandFromJSON,
    CreateShoppingCartCommandToJSON,
    CriteriaSortItem,
    CriteriaSortItemFromJSON,
    CriteriaSortItemToJSON,
    ManageQuotesVm,
    ManageQuotesVmFromJSON,
    ManageQuotesVmToJSON,
    PlaceOrderWithoutApprovalCommand,
    PlaceOrderWithoutApprovalCommandFromJSON,
    PlaceOrderWithoutApprovalCommandToJSON,
    QuotationRequestedCommand,
    QuotationRequestedCommandFromJSON,
    QuotationRequestedCommandToJSON,
    QuoteDto,
    QuoteDtoFromJSON,
    QuoteDtoToJSON,
    QuoteStateTypes,
    QuoteStateTypesFromJSON,
    QuoteStateTypesToJSON,
    RequestOrderApprovalCommand,
    RequestOrderApprovalCommandFromJSON,
    RequestOrderApprovalCommandToJSON,
    SalesChannelDto,
    SalesChannelDtoFromJSON,
    SalesChannelDtoToJSON,
    SaveQuoteDto,
    SaveQuoteDtoFromJSON,
    SaveQuoteDtoToJSON,
    ShoppingCartAttachmentTypes,
    ShoppingCartAttachmentTypesFromJSON,
    ShoppingCartAttachmentTypesToJSON,
    ShoppingCartDto,
    ShoppingCartDtoFromJSON,
    ShoppingCartDtoToJSON,
    ShoppingCartItemAdditionalInformationUpdatedDto,
    ShoppingCartItemAdditionalInformationUpdatedDtoFromJSON,
    ShoppingCartItemAdditionalInformationUpdatedDtoToJSON,
    ShoppingCartItemSoftwarePurchaseEmailUpdatedDto,
    ShoppingCartItemSoftwarePurchaseEmailUpdatedDtoFromJSON,
    ShoppingCartItemSoftwarePurchaseEmailUpdatedDtoToJSON,
    ShoppingCartNameUpdatedDto,
    ShoppingCartNameUpdatedDtoFromJSON,
    ShoppingCartNameUpdatedDtoToJSON,
    ShoppingCartStateTypes,
    ShoppingCartStateTypesFromJSON,
    ShoppingCartStateTypesToJSON,
    ShoppingCartUpdatedDto,
    ShoppingCartUpdatedDtoFromJSON,
    ShoppingCartUpdatedDtoToJSON,
    TermsOfDeliveryDto,
    TermsOfDeliveryDtoFromJSON,
    TermsOfDeliveryDtoToJSON,
    UpdateQuoteProjectDto,
    UpdateQuoteProjectDtoFromJSON,
    UpdateQuoteProjectDtoToJSON,
    UpdateShoppingCartItemAdditionalInformationDto,
    UpdateShoppingCartItemAdditionalInformationDtoFromJSON,
    UpdateShoppingCartItemAdditionalInformationDtoToJSON,
    UpdateShoppingCartItemSoftwarePurchaseEmailDto,
    UpdateShoppingCartItemSoftwarePurchaseEmailDtoFromJSON,
    UpdateShoppingCartItemSoftwarePurchaseEmailDtoToJSON,
    UpdateShoppingCartName,
    UpdateShoppingCartNameFromJSON,
    UpdateShoppingCartNameToJSON,
    UpdateShoppingCartPriceListCommand,
    UpdateShoppingCartPriceListCommandFromJSON,
    UpdateShoppingCartPriceListCommandToJSON,
    UserShoppingCartsVm,
    UserShoppingCartsVmFromJSON,
    UserShoppingCartsVmToJSON,
} from '../models';

export interface ApiShoppingCartsActivateGuidPatchRequest {
    guid: string;
}

export interface ApiShoppingCartsApproveQuotePatchRequest {
    approveQuoteCommand?: ApproveQuoteCommand;
}

export interface ApiShoppingCartsCancelQuotationRequestGuidPatchRequest {
    guid: string;
}

export interface ApiShoppingCartsGetRequest {
    criteriaPage: number;
    criteriaPageSize: number;
    criteriaStateIds?: Array<ShoppingCartStateTypes> | null;
    criteriaName?: string | null;
    criteriaReference?: string | null;
    criteriaCreatedFrom?: Date | null;
    criteriaCreatedTo?: Date | null;
    criteriaSortColumn?: string | null;
    criteriaIsAscendingOrder?: boolean;
    criteriaSortItems?: Array<CriteriaSortItem> | null;
    criteriaSkipTotalRowCount?: boolean;
    criteriaQuerySortByColumn?: string | null;
}

export interface ApiShoppingCartsGuidArchivePatchRequest {
    guid: string;
}

export interface ApiShoppingCartsGuidAttachmentAttachmentIdDeleteRequest {
    guid: string;
    attachmentId: string;
}

export interface ApiShoppingCartsGuidAttachmentAttachmentIdGetRequest {
    guid: string;
    attachmentId: string;
}

export interface ApiShoppingCartsGuidAttachmentTypePostRequest {
    guid: string;
    type: ShoppingCartAttachmentTypes;
    uploadedFile?: Blob | null;
}

export interface ApiShoppingCartsGuidCreateQuotePutRequest {
    guid: string;
    createQuoteDto?: CreateQuoteDto;
}

export interface ApiShoppingCartsGuidGetRequest {
    guid: string;
}

export interface ApiShoppingCartsGuidNamePatchRequest {
    guid: string;
    updateShoppingCartName?: UpdateShoppingCartName;
}

export interface ApiShoppingCartsGuidOrderPlacedExternallyPatchRequest {
    guid: string;
}

export interface ApiShoppingCartsGuidPlaceOrderFromWaitingForApprovalCommandPatchRequest {
    guid: string;
}

export interface ApiShoppingCartsGuidRejectApprovalPatchRequest {
    guid: string;
}

export interface ApiShoppingCartsGuidRejectQuotePatchRequest {
    guid: string;
}

export interface ApiShoppingCartsGuidRequestQuoteApprovalPostRequest {
    guid: string;
    saveQuoteDto: SaveQuoteDto;
    approverEmail?: string | null;
    isOnlyAddedApprover?: boolean;
}

export interface ApiShoppingCartsGuidSendQuoteWithoutApprovalPostRequest {
    guid: string;
    saveQuoteDto: SaveQuoteDto;
}

export interface ApiShoppingCartsGuidUpdateProjectPatchRequest {
    guid: string;
    updateQuoteProjectDto: UpdateQuoteProjectDto;
}

export interface ApiShoppingCartsItemsPutRequest {
    addOrUpdateShoppingCartItemsCommand?: AddOrUpdateShoppingCartItemsCommand;
}

export interface ApiShoppingCartsManageQuotesGetRequest {
    criteriaPage: number;
    criteriaPageSize: number;
    criteriaStateIds?: Array<QuoteStateTypes> | null;
    criteriaReference?: string | null;
    criteriaQuoteRequestedDateFrom?: Date | null;
    criteriaQuoteRequestedDateTo?: Date | null;
    criteriaCreatedBy?: string | null;
    criteriaCompanyDisplayName?: string | null;
    criteriaTotalPriceTo?: number | null;
    criteriaTotalPriceFrom?: number | null;
    criteriaTotalQuotedPriceTo?: number | null;
    criteriaTotalQuotedPriceFrom?: number | null;
    criteriaTotalDiscountPercentageTo?: number | null;
    criteriaTotalDiscountPercentageFrom?: number | null;
    criteriaTotalQtyTo?: number | null;
    criteriaTotalQtyFrom?: number | null;
    criteriaQuerySortByColumn?: string | null;
    criteriaSortColumn?: string | null;
    criteriaIsAscendingOrder?: boolean;
    criteriaSortItems?: Array<CriteriaSortItem> | null;
    criteriaSkipTotalRowCount?: boolean;
}

export interface ApiShoppingCartsManageQuotesIdGetRequest {
    id: number;
}

export interface ApiShoppingCartsPlaceOrderWithoutApprovalPostRequest {
    placeOrderWithoutApprovalCommand?: PlaceOrderWithoutApprovalCommand;
}

export interface ApiShoppingCartsPostRequest {
    createShoppingCartCommand?: CreateShoppingCartCommand;
}

export interface ApiShoppingCartsPriceListPatchRequest {
    updateShoppingCartPriceListCommand?: UpdateShoppingCartPriceListCommand;
}

export interface ApiShoppingCartsRequestOrderApprovalPostRequest {
    requestOrderApprovalCommand?: RequestOrderApprovalCommand;
}

export interface ApiShoppingCartsRequestQuotationPatchRequest {
    quotationRequestedCommand?: QuotationRequestedCommand;
}

export interface ApiShoppingCartsShoppingCartItemIdAdditionalInformationPatchRequest {
    id: number;
    updateShoppingCartItemAdditionalInformationDto?: UpdateShoppingCartItemAdditionalInformationDto;
}

export interface ApiShoppingCartsShoppingCartItemIdDeleteRequest {
    id: number;
    serialNumber?: string | null;
}

export interface ApiShoppingCartsShoppingCartItemIdSoftwarePurchaseEmailPatchRequest {
    id: number;
    updateShoppingCartItemSoftwarePurchaseEmailDto?: UpdateShoppingCartItemSoftwarePurchaseEmailDto;
}

export interface ApiShoppingCartsTermsOfDeliveriesGetRequest {
    canUse?: boolean | null;
}

/**
 * 
 */
export class ShoppingCartsApi extends runtime.BaseAPI {

    /**
     */
    async apiShoppingCartsActivateGuidPatchRaw(requestParameters: ApiShoppingCartsActivateGuidPatchRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ShoppingCartUpdatedDto>> {
        if (requestParameters.guid === null || requestParameters.guid === undefined) {
            throw new runtime.RequiredError('guid','Required parameter requestParameters.guid was null or undefined when calling apiShoppingCartsActivateGuidPatch.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/ShoppingCarts/Activate/{guid}`.replace(`{${"guid"}}`, encodeURIComponent(String(requestParameters.guid))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShoppingCartUpdatedDtoFromJSON(jsonValue));
    }

    /**
     */
    async apiShoppingCartsActivateGuidPatch(requestParameters: ApiShoppingCartsActivateGuidPatchRequest, initOverrides?: RequestInit): Promise<ShoppingCartUpdatedDto> {
        const response = await this.apiShoppingCartsActivateGuidPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiShoppingCartsActiveShoppingCartModificationInfoGetRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<number>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/ShoppingCarts/ActiveShoppingCartModificationInfo`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async apiShoppingCartsActiveShoppingCartModificationInfoGet(initOverrides?: RequestInit): Promise<number> {
        const response = await this.apiShoppingCartsActiveShoppingCartModificationInfoGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiShoppingCartsApproveQuotePatchRaw(requestParameters: ApiShoppingCartsApproveQuotePatchRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/ShoppingCarts/ApproveQuote`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ApproveQuoteCommandToJSON(requestParameters.approveQuoteCommand),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiShoppingCartsApproveQuotePatch(requestParameters: ApiShoppingCartsApproveQuotePatchRequest, initOverrides?: RequestInit): Promise<void> {
        await this.apiShoppingCartsApproveQuotePatchRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiShoppingCartsCancelQuotationRequestGuidPatchRaw(requestParameters: ApiShoppingCartsCancelQuotationRequestGuidPatchRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.guid === null || requestParameters.guid === undefined) {
            throw new runtime.RequiredError('guid','Required parameter requestParameters.guid was null or undefined when calling apiShoppingCartsCancelQuotationRequestGuidPatch.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/ShoppingCarts/CancelQuotationRequest/{guid}`.replace(`{${"guid"}}`, encodeURIComponent(String(requestParameters.guid))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiShoppingCartsCancelQuotationRequestGuidPatch(requestParameters: ApiShoppingCartsCancelQuotationRequestGuidPatchRequest, initOverrides?: RequestInit): Promise<void> {
        await this.apiShoppingCartsCancelQuotationRequestGuidPatchRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiShoppingCartsGetRaw(requestParameters: ApiShoppingCartsGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<UserShoppingCartsVm>> {
        if (requestParameters.criteriaPage === null || requestParameters.criteriaPage === undefined) {
            throw new runtime.RequiredError('criteriaPage','Required parameter requestParameters.criteriaPage was null or undefined when calling apiShoppingCartsGet.');
        }

        if (requestParameters.criteriaPageSize === null || requestParameters.criteriaPageSize === undefined) {
            throw new runtime.RequiredError('criteriaPageSize','Required parameter requestParameters.criteriaPageSize was null or undefined when calling apiShoppingCartsGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.criteriaStateIds) {
            queryParameters['Criteria.StateIds'] = requestParameters.criteriaStateIds;
        }

        if (requestParameters.criteriaName !== undefined) {
            queryParameters['Criteria.Name'] = requestParameters.criteriaName;
        }

        if (requestParameters.criteriaReference !== undefined) {
            queryParameters['Criteria.Reference'] = requestParameters.criteriaReference;
        }

        if (requestParameters.criteriaCreatedFrom !== undefined) {
            queryParameters['Criteria.CreatedFrom'] = (requestParameters.criteriaCreatedFrom as any).toISOString();
        }

        if (requestParameters.criteriaCreatedTo !== undefined) {
            queryParameters['Criteria.CreatedTo'] = (requestParameters.criteriaCreatedTo as any).toISOString();
        }

        if (requestParameters.criteriaSortColumn !== undefined) {
            queryParameters['Criteria.SortColumn'] = requestParameters.criteriaSortColumn;
        }

        if (requestParameters.criteriaIsAscendingOrder !== undefined) {
            queryParameters['Criteria.IsAscendingOrder'] = requestParameters.criteriaIsAscendingOrder;
        }

        if (requestParameters.criteriaSortItems) {
            queryParameters['Criteria.SortItems'] = requestParameters.criteriaSortItems;
        }

        if (requestParameters.criteriaPage !== undefined) {
            queryParameters['Criteria.Page'] = requestParameters.criteriaPage;
        }

        if (requestParameters.criteriaPageSize !== undefined) {
            queryParameters['Criteria.PageSize'] = requestParameters.criteriaPageSize;
        }

        if (requestParameters.criteriaSkipTotalRowCount !== undefined) {
            queryParameters['Criteria.SkipTotalRowCount'] = requestParameters.criteriaSkipTotalRowCount;
        }

        if (requestParameters.criteriaQuerySortByColumn !== undefined) {
            queryParameters['Criteria.QuerySortByColumn'] = requestParameters.criteriaQuerySortByColumn;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/ShoppingCarts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserShoppingCartsVmFromJSON(jsonValue));
    }

    /**
     */
    async apiShoppingCartsGet(requestParameters: ApiShoppingCartsGetRequest, initOverrides?: RequestInit): Promise<UserShoppingCartsVm> {
        const response = await this.apiShoppingCartsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiShoppingCartsGuidArchivePatchRaw(requestParameters: ApiShoppingCartsGuidArchivePatchRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.guid === null || requestParameters.guid === undefined) {
            throw new runtime.RequiredError('guid','Required parameter requestParameters.guid was null or undefined when calling apiShoppingCartsGuidArchivePatch.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/ShoppingCarts/{guid}/Archive`.replace(`{${"guid"}}`, encodeURIComponent(String(requestParameters.guid))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiShoppingCartsGuidArchivePatch(requestParameters: ApiShoppingCartsGuidArchivePatchRequest, initOverrides?: RequestInit): Promise<void> {
        await this.apiShoppingCartsGuidArchivePatchRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiShoppingCartsGuidAttachmentAttachmentIdDeleteRaw(requestParameters: ApiShoppingCartsGuidAttachmentAttachmentIdDeleteRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.guid === null || requestParameters.guid === undefined) {
            throw new runtime.RequiredError('guid','Required parameter requestParameters.guid was null or undefined when calling apiShoppingCartsGuidAttachmentAttachmentIdDelete.');
        }

        if (requestParameters.attachmentId === null || requestParameters.attachmentId === undefined) {
            throw new runtime.RequiredError('attachmentId','Required parameter requestParameters.attachmentId was null or undefined when calling apiShoppingCartsGuidAttachmentAttachmentIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/ShoppingCarts/{guid}/Attachment/{attachmentId}`.replace(`{${"guid"}}`, encodeURIComponent(String(requestParameters.guid))).replace(`{${"attachmentId"}}`, encodeURIComponent(String(requestParameters.attachmentId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async apiShoppingCartsGuidAttachmentAttachmentIdDelete(requestParameters: ApiShoppingCartsGuidAttachmentAttachmentIdDeleteRequest, initOverrides?: RequestInit): Promise<string> {
        const response = await this.apiShoppingCartsGuidAttachmentAttachmentIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiShoppingCartsGuidAttachmentAttachmentIdGetRaw(requestParameters: ApiShoppingCartsGuidAttachmentAttachmentIdGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.guid === null || requestParameters.guid === undefined) {
            throw new runtime.RequiredError('guid','Required parameter requestParameters.guid was null or undefined when calling apiShoppingCartsGuidAttachmentAttachmentIdGet.');
        }

        if (requestParameters.attachmentId === null || requestParameters.attachmentId === undefined) {
            throw new runtime.RequiredError('attachmentId','Required parameter requestParameters.attachmentId was null or undefined when calling apiShoppingCartsGuidAttachmentAttachmentIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/ShoppingCarts/{guid}/Attachment/{attachmentId}`.replace(`{${"guid"}}`, encodeURIComponent(String(requestParameters.guid))).replace(`{${"attachmentId"}}`, encodeURIComponent(String(requestParameters.attachmentId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async apiShoppingCartsGuidAttachmentAttachmentIdGet(requestParameters: ApiShoppingCartsGuidAttachmentAttachmentIdGetRequest, initOverrides?: RequestInit): Promise<Blob> {
        const response = await this.apiShoppingCartsGuidAttachmentAttachmentIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiShoppingCartsGuidAttachmentTypePostRaw(requestParameters: ApiShoppingCartsGuidAttachmentTypePostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<AttachmentCreatedDto>> {
        if (requestParameters.guid === null || requestParameters.guid === undefined) {
            throw new runtime.RequiredError('guid','Required parameter requestParameters.guid was null or undefined when calling apiShoppingCartsGuidAttachmentTypePost.');
        }

        if (requestParameters.type === null || requestParameters.type === undefined) {
            throw new runtime.RequiredError('type','Required parameter requestParameters.type was null or undefined when calling apiShoppingCartsGuidAttachmentTypePost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.uploadedFile !== undefined) {
            formParams.append('uploadedFile', requestParameters.uploadedFile as any);
        }

        const response = await this.request({
            path: `/api/ShoppingCarts/{guid}/Attachment/{type}`.replace(`{${"guid"}}`, encodeURIComponent(String(requestParameters.guid))).replace(`{${"type"}}`, encodeURIComponent(String(requestParameters.type))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AttachmentCreatedDtoFromJSON(jsonValue));
    }

    /**
     */
    async apiShoppingCartsGuidAttachmentTypePost(requestParameters: ApiShoppingCartsGuidAttachmentTypePostRequest, initOverrides?: RequestInit): Promise<AttachmentCreatedDto> {
        const response = await this.apiShoppingCartsGuidAttachmentTypePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiShoppingCartsGuidCreateQuotePutRaw(requestParameters: ApiShoppingCartsGuidCreateQuotePutRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.guid === null || requestParameters.guid === undefined) {
            throw new runtime.RequiredError('guid','Required parameter requestParameters.guid was null or undefined when calling apiShoppingCartsGuidCreateQuotePut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/ShoppingCarts/{guid}/CreateQuote`.replace(`{${"guid"}}`, encodeURIComponent(String(requestParameters.guid))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateQuoteDtoToJSON(requestParameters.createQuoteDto),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiShoppingCartsGuidCreateQuotePut(requestParameters: ApiShoppingCartsGuidCreateQuotePutRequest, initOverrides?: RequestInit): Promise<void> {
        await this.apiShoppingCartsGuidCreateQuotePutRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiShoppingCartsGuidGetRaw(requestParameters: ApiShoppingCartsGuidGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ShoppingCartDto>> {
        if (requestParameters.guid === null || requestParameters.guid === undefined) {
            throw new runtime.RequiredError('guid','Required parameter requestParameters.guid was null or undefined when calling apiShoppingCartsGuidGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/ShoppingCarts/{guid}`.replace(`{${"guid"}}`, encodeURIComponent(String(requestParameters.guid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShoppingCartDtoFromJSON(jsonValue));
    }

    /**
     */
    async apiShoppingCartsGuidGet(requestParameters: ApiShoppingCartsGuidGetRequest, initOverrides?: RequestInit): Promise<ShoppingCartDto> {
        const response = await this.apiShoppingCartsGuidGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiShoppingCartsGuidNamePatchRaw(requestParameters: ApiShoppingCartsGuidNamePatchRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ShoppingCartNameUpdatedDto>> {
        if (requestParameters.guid === null || requestParameters.guid === undefined) {
            throw new runtime.RequiredError('guid','Required parameter requestParameters.guid was null or undefined when calling apiShoppingCartsGuidNamePatch.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/ShoppingCarts/{guid}/Name`.replace(`{${"guid"}}`, encodeURIComponent(String(requestParameters.guid))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateShoppingCartNameToJSON(requestParameters.updateShoppingCartName),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShoppingCartNameUpdatedDtoFromJSON(jsonValue));
    }

    /**
     */
    async apiShoppingCartsGuidNamePatch(requestParameters: ApiShoppingCartsGuidNamePatchRequest, initOverrides?: RequestInit): Promise<ShoppingCartNameUpdatedDto> {
        const response = await this.apiShoppingCartsGuidNamePatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiShoppingCartsGuidOrderPlacedExternallyPatchRaw(requestParameters: ApiShoppingCartsGuidOrderPlacedExternallyPatchRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.guid === null || requestParameters.guid === undefined) {
            throw new runtime.RequiredError('guid','Required parameter requestParameters.guid was null or undefined when calling apiShoppingCartsGuidOrderPlacedExternallyPatch.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/ShoppingCarts/{guid}/OrderPlacedExternally`.replace(`{${"guid"}}`, encodeURIComponent(String(requestParameters.guid))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiShoppingCartsGuidOrderPlacedExternallyPatch(requestParameters: ApiShoppingCartsGuidOrderPlacedExternallyPatchRequest, initOverrides?: RequestInit): Promise<void> {
        await this.apiShoppingCartsGuidOrderPlacedExternallyPatchRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiShoppingCartsGuidPlaceOrderFromWaitingForApprovalCommandPatchRaw(requestParameters: ApiShoppingCartsGuidPlaceOrderFromWaitingForApprovalCommandPatchRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.guid === null || requestParameters.guid === undefined) {
            throw new runtime.RequiredError('guid','Required parameter requestParameters.guid was null or undefined when calling apiShoppingCartsGuidPlaceOrderFromWaitingForApprovalCommandPatch.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/ShoppingCarts/{guid}/PlaceOrderFromWaitingForApprovalCommand`.replace(`{${"guid"}}`, encodeURIComponent(String(requestParameters.guid))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiShoppingCartsGuidPlaceOrderFromWaitingForApprovalCommandPatch(requestParameters: ApiShoppingCartsGuidPlaceOrderFromWaitingForApprovalCommandPatchRequest, initOverrides?: RequestInit): Promise<void> {
        await this.apiShoppingCartsGuidPlaceOrderFromWaitingForApprovalCommandPatchRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiShoppingCartsGuidRejectApprovalPatchRaw(requestParameters: ApiShoppingCartsGuidRejectApprovalPatchRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.guid === null || requestParameters.guid === undefined) {
            throw new runtime.RequiredError('guid','Required parameter requestParameters.guid was null or undefined when calling apiShoppingCartsGuidRejectApprovalPatch.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/ShoppingCarts/{guid}/RejectApproval`.replace(`{${"guid"}}`, encodeURIComponent(String(requestParameters.guid))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiShoppingCartsGuidRejectApprovalPatch(requestParameters: ApiShoppingCartsGuidRejectApprovalPatchRequest, initOverrides?: RequestInit): Promise<void> {
        await this.apiShoppingCartsGuidRejectApprovalPatchRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiShoppingCartsGuidRejectQuotePatchRaw(requestParameters: ApiShoppingCartsGuidRejectQuotePatchRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.guid === null || requestParameters.guid === undefined) {
            throw new runtime.RequiredError('guid','Required parameter requestParameters.guid was null or undefined when calling apiShoppingCartsGuidRejectQuotePatch.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/ShoppingCarts/{guid}/RejectQuote`.replace(`{${"guid"}}`, encodeURIComponent(String(requestParameters.guid))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiShoppingCartsGuidRejectQuotePatch(requestParameters: ApiShoppingCartsGuidRejectQuotePatchRequest, initOverrides?: RequestInit): Promise<void> {
        await this.apiShoppingCartsGuidRejectQuotePatchRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiShoppingCartsGuidRequestQuoteApprovalPostRaw(requestParameters: ApiShoppingCartsGuidRequestQuoteApprovalPostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.guid === null || requestParameters.guid === undefined) {
            throw new runtime.RequiredError('guid','Required parameter requestParameters.guid was null or undefined when calling apiShoppingCartsGuidRequestQuoteApprovalPost.');
        }

        if (requestParameters.saveQuoteDto === null || requestParameters.saveQuoteDto === undefined) {
            throw new runtime.RequiredError('saveQuoteDto','Required parameter requestParameters.saveQuoteDto was null or undefined when calling apiShoppingCartsGuidRequestQuoteApprovalPost.');
        }

        const queryParameters: any = {};

        if (requestParameters.approverEmail !== undefined) {
            queryParameters['approverEmail'] = requestParameters.approverEmail;
        }

        if (requestParameters.isOnlyAddedApprover !== undefined) {
            queryParameters['isOnlyAddedApprover'] = requestParameters.isOnlyAddedApprover;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/ShoppingCarts/{guid}/RequestQuoteApproval`.replace(`{${"guid"}}`, encodeURIComponent(String(requestParameters.guid))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SaveQuoteDtoToJSON(requestParameters.saveQuoteDto),
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async apiShoppingCartsGuidRequestQuoteApprovalPost(requestParameters: ApiShoppingCartsGuidRequestQuoteApprovalPostRequest, initOverrides?: RequestInit): Promise<number> {
        const response = await this.apiShoppingCartsGuidRequestQuoteApprovalPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiShoppingCartsGuidSendQuoteWithoutApprovalPostRaw(requestParameters: ApiShoppingCartsGuidSendQuoteWithoutApprovalPostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.guid === null || requestParameters.guid === undefined) {
            throw new runtime.RequiredError('guid','Required parameter requestParameters.guid was null or undefined when calling apiShoppingCartsGuidSendQuoteWithoutApprovalPost.');
        }

        if (requestParameters.saveQuoteDto === null || requestParameters.saveQuoteDto === undefined) {
            throw new runtime.RequiredError('saveQuoteDto','Required parameter requestParameters.saveQuoteDto was null or undefined when calling apiShoppingCartsGuidSendQuoteWithoutApprovalPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/ShoppingCarts/{guid}/SendQuoteWithoutApproval`.replace(`{${"guid"}}`, encodeURIComponent(String(requestParameters.guid))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SaveQuoteDtoToJSON(requestParameters.saveQuoteDto),
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async apiShoppingCartsGuidSendQuoteWithoutApprovalPost(requestParameters: ApiShoppingCartsGuidSendQuoteWithoutApprovalPostRequest, initOverrides?: RequestInit): Promise<number> {
        const response = await this.apiShoppingCartsGuidSendQuoteWithoutApprovalPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiShoppingCartsGuidUpdateProjectPatchRaw(requestParameters: ApiShoppingCartsGuidUpdateProjectPatchRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.guid === null || requestParameters.guid === undefined) {
            throw new runtime.RequiredError('guid','Required parameter requestParameters.guid was null or undefined when calling apiShoppingCartsGuidUpdateProjectPatch.');
        }

        if (requestParameters.updateQuoteProjectDto === null || requestParameters.updateQuoteProjectDto === undefined) {
            throw new runtime.RequiredError('updateQuoteProjectDto','Required parameter requestParameters.updateQuoteProjectDto was null or undefined when calling apiShoppingCartsGuidUpdateProjectPatch.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/ShoppingCarts/{guid}/UpdateProject`.replace(`{${"guid"}}`, encodeURIComponent(String(requestParameters.guid))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateQuoteProjectDtoToJSON(requestParameters.updateQuoteProjectDto),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiShoppingCartsGuidUpdateProjectPatch(requestParameters: ApiShoppingCartsGuidUpdateProjectPatchRequest, initOverrides?: RequestInit): Promise<void> {
        await this.apiShoppingCartsGuidUpdateProjectPatchRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiShoppingCartsItemsPutRaw(requestParameters: ApiShoppingCartsItemsPutRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/ShoppingCarts/Items`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AddOrUpdateShoppingCartItemsCommandToJSON(requestParameters.addOrUpdateShoppingCartItemsCommand),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiShoppingCartsItemsPut(requestParameters: ApiShoppingCartsItemsPutRequest, initOverrides?: RequestInit): Promise<void> {
        await this.apiShoppingCartsItemsPutRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiShoppingCartsManageQuotesGetRaw(requestParameters: ApiShoppingCartsManageQuotesGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ManageQuotesVm>> {
        if (requestParameters.criteriaPage === null || requestParameters.criteriaPage === undefined) {
            throw new runtime.RequiredError('criteriaPage','Required parameter requestParameters.criteriaPage was null or undefined when calling apiShoppingCartsManageQuotesGet.');
        }

        if (requestParameters.criteriaPageSize === null || requestParameters.criteriaPageSize === undefined) {
            throw new runtime.RequiredError('criteriaPageSize','Required parameter requestParameters.criteriaPageSize was null or undefined when calling apiShoppingCartsManageQuotesGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.criteriaStateIds) {
            queryParameters['Criteria.StateIds'] = requestParameters.criteriaStateIds;
        }

        if (requestParameters.criteriaReference !== undefined) {
            queryParameters['Criteria.Reference'] = requestParameters.criteriaReference;
        }

        if (requestParameters.criteriaQuoteRequestedDateFrom !== undefined) {
            queryParameters['Criteria.QuoteRequestedDateFrom'] = (requestParameters.criteriaQuoteRequestedDateFrom as any).toISOString();
        }

        if (requestParameters.criteriaQuoteRequestedDateTo !== undefined) {
            queryParameters['Criteria.QuoteRequestedDateTo'] = (requestParameters.criteriaQuoteRequestedDateTo as any).toISOString();
        }

        if (requestParameters.criteriaCreatedBy !== undefined) {
            queryParameters['Criteria.CreatedBy'] = requestParameters.criteriaCreatedBy;
        }

        if (requestParameters.criteriaCompanyDisplayName !== undefined) {
            queryParameters['Criteria.CompanyDisplayName'] = requestParameters.criteriaCompanyDisplayName;
        }

        if (requestParameters.criteriaTotalPriceTo !== undefined) {
            queryParameters['Criteria.TotalPriceTo'] = requestParameters.criteriaTotalPriceTo;
        }

        if (requestParameters.criteriaTotalPriceFrom !== undefined) {
            queryParameters['Criteria.TotalPriceFrom'] = requestParameters.criteriaTotalPriceFrom;
        }

        if (requestParameters.criteriaTotalQuotedPriceTo !== undefined) {
            queryParameters['Criteria.TotalQuotedPriceTo'] = requestParameters.criteriaTotalQuotedPriceTo;
        }

        if (requestParameters.criteriaTotalQuotedPriceFrom !== undefined) {
            queryParameters['Criteria.TotalQuotedPriceFrom'] = requestParameters.criteriaTotalQuotedPriceFrom;
        }

        if (requestParameters.criteriaTotalDiscountPercentageTo !== undefined) {
            queryParameters['Criteria.TotalDiscountPercentageTo'] = requestParameters.criteriaTotalDiscountPercentageTo;
        }

        if (requestParameters.criteriaTotalDiscountPercentageFrom !== undefined) {
            queryParameters['Criteria.TotalDiscountPercentageFrom'] = requestParameters.criteriaTotalDiscountPercentageFrom;
        }

        if (requestParameters.criteriaTotalQtyTo !== undefined) {
            queryParameters['Criteria.TotalQtyTo'] = requestParameters.criteriaTotalQtyTo;
        }

        if (requestParameters.criteriaTotalQtyFrom !== undefined) {
            queryParameters['Criteria.TotalQtyFrom'] = requestParameters.criteriaTotalQtyFrom;
        }

        if (requestParameters.criteriaQuerySortByColumn !== undefined) {
            queryParameters['Criteria.QuerySortByColumn'] = requestParameters.criteriaQuerySortByColumn;
        }

        if (requestParameters.criteriaSortColumn !== undefined) {
            queryParameters['Criteria.SortColumn'] = requestParameters.criteriaSortColumn;
        }

        if (requestParameters.criteriaIsAscendingOrder !== undefined) {
            queryParameters['Criteria.IsAscendingOrder'] = requestParameters.criteriaIsAscendingOrder;
        }

        if (requestParameters.criteriaSortItems) {
            queryParameters['Criteria.SortItems'] = requestParameters.criteriaSortItems;
        }

        if (requestParameters.criteriaPage !== undefined) {
            queryParameters['Criteria.Page'] = requestParameters.criteriaPage;
        }

        if (requestParameters.criteriaPageSize !== undefined) {
            queryParameters['Criteria.PageSize'] = requestParameters.criteriaPageSize;
        }

        if (requestParameters.criteriaSkipTotalRowCount !== undefined) {
            queryParameters['Criteria.SkipTotalRowCount'] = requestParameters.criteriaSkipTotalRowCount;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/ShoppingCarts/ManageQuotes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ManageQuotesVmFromJSON(jsonValue));
    }

    /**
     */
    async apiShoppingCartsManageQuotesGet(requestParameters: ApiShoppingCartsManageQuotesGetRequest, initOverrides?: RequestInit): Promise<ManageQuotesVm> {
        const response = await this.apiShoppingCartsManageQuotesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiShoppingCartsManageQuotesIdGetRaw(requestParameters: ApiShoppingCartsManageQuotesIdGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<QuoteDto>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiShoppingCartsManageQuotesIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/ShoppingCarts/ManageQuotes/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => QuoteDtoFromJSON(jsonValue));
    }

    /**
     */
    async apiShoppingCartsManageQuotesIdGet(requestParameters: ApiShoppingCartsManageQuotesIdGetRequest, initOverrides?: RequestInit): Promise<QuoteDto> {
        const response = await this.apiShoppingCartsManageQuotesIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiShoppingCartsPlaceOrderWithoutApprovalPostRaw(requestParameters: ApiShoppingCartsPlaceOrderWithoutApprovalPostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/ShoppingCarts/PlaceOrderWithoutApproval`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PlaceOrderWithoutApprovalCommandToJSON(requestParameters.placeOrderWithoutApprovalCommand),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiShoppingCartsPlaceOrderWithoutApprovalPost(requestParameters: ApiShoppingCartsPlaceOrderWithoutApprovalPostRequest, initOverrides?: RequestInit): Promise<void> {
        await this.apiShoppingCartsPlaceOrderWithoutApprovalPostRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiShoppingCartsPostRaw(requestParameters: ApiShoppingCartsPostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ShoppingCartUpdatedDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/ShoppingCarts`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateShoppingCartCommandToJSON(requestParameters.createShoppingCartCommand),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShoppingCartUpdatedDtoFromJSON(jsonValue));
    }

    /**
     */
    async apiShoppingCartsPost(requestParameters: ApiShoppingCartsPostRequest, initOverrides?: RequestInit): Promise<ShoppingCartUpdatedDto> {
        const response = await this.apiShoppingCartsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiShoppingCartsPriceListPatchRaw(requestParameters: ApiShoppingCartsPriceListPatchRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/ShoppingCarts/PriceList`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateShoppingCartPriceListCommandToJSON(requestParameters.updateShoppingCartPriceListCommand),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiShoppingCartsPriceListPatch(requestParameters: ApiShoppingCartsPriceListPatchRequest, initOverrides?: RequestInit): Promise<void> {
        await this.apiShoppingCartsPriceListPatchRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiShoppingCartsRequestOrderApprovalPostRaw(requestParameters: ApiShoppingCartsRequestOrderApprovalPostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/ShoppingCarts/RequestOrderApproval`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestOrderApprovalCommandToJSON(requestParameters.requestOrderApprovalCommand),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiShoppingCartsRequestOrderApprovalPost(requestParameters: ApiShoppingCartsRequestOrderApprovalPostRequest, initOverrides?: RequestInit): Promise<void> {
        await this.apiShoppingCartsRequestOrderApprovalPostRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiShoppingCartsRequestQuotationPatchRaw(requestParameters: ApiShoppingCartsRequestQuotationPatchRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/ShoppingCarts/RequestQuotation`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: QuotationRequestedCommandToJSON(requestParameters.quotationRequestedCommand),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiShoppingCartsRequestQuotationPatch(requestParameters: ApiShoppingCartsRequestQuotationPatchRequest, initOverrides?: RequestInit): Promise<void> {
        await this.apiShoppingCartsRequestQuotationPatchRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiShoppingCartsSalesChannelsGetRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<SalesChannelDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/ShoppingCarts/SalesChannels`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SalesChannelDtoFromJSON));
    }

    /**
     */
    async apiShoppingCartsSalesChannelsGet(initOverrides?: RequestInit): Promise<Array<SalesChannelDto>> {
        const response = await this.apiShoppingCartsSalesChannelsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiShoppingCartsShoppingCartItemIdAdditionalInformationPatchRaw(requestParameters: ApiShoppingCartsShoppingCartItemIdAdditionalInformationPatchRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ShoppingCartItemAdditionalInformationUpdatedDto>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiShoppingCartsShoppingCartItemIdAdditionalInformationPatch.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/ShoppingCarts/ShoppingCartItem/{id}/AdditionalInformation`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateShoppingCartItemAdditionalInformationDtoToJSON(requestParameters.updateShoppingCartItemAdditionalInformationDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShoppingCartItemAdditionalInformationUpdatedDtoFromJSON(jsonValue));
    }

    /**
     */
    async apiShoppingCartsShoppingCartItemIdAdditionalInformationPatch(requestParameters: ApiShoppingCartsShoppingCartItemIdAdditionalInformationPatchRequest, initOverrides?: RequestInit): Promise<ShoppingCartItemAdditionalInformationUpdatedDto> {
        const response = await this.apiShoppingCartsShoppingCartItemIdAdditionalInformationPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiShoppingCartsShoppingCartItemIdDeleteRaw(requestParameters: ApiShoppingCartsShoppingCartItemIdDeleteRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiShoppingCartsShoppingCartItemIdDelete.');
        }

        const queryParameters: any = {};

        if (requestParameters.serialNumber !== undefined) {
            queryParameters['serialNumber'] = requestParameters.serialNumber;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/ShoppingCarts/ShoppingCartItem/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiShoppingCartsShoppingCartItemIdDelete(requestParameters: ApiShoppingCartsShoppingCartItemIdDeleteRequest, initOverrides?: RequestInit): Promise<void> {
        await this.apiShoppingCartsShoppingCartItemIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiShoppingCartsShoppingCartItemIdSoftwarePurchaseEmailPatchRaw(requestParameters: ApiShoppingCartsShoppingCartItemIdSoftwarePurchaseEmailPatchRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ShoppingCartItemSoftwarePurchaseEmailUpdatedDto>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiShoppingCartsShoppingCartItemIdSoftwarePurchaseEmailPatch.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/ShoppingCarts/ShoppingCartItem/{id}/SoftwarePurchaseEmail`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateShoppingCartItemSoftwarePurchaseEmailDtoToJSON(requestParameters.updateShoppingCartItemSoftwarePurchaseEmailDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShoppingCartItemSoftwarePurchaseEmailUpdatedDtoFromJSON(jsonValue));
    }

    /**
     */
    async apiShoppingCartsShoppingCartItemIdSoftwarePurchaseEmailPatch(requestParameters: ApiShoppingCartsShoppingCartItemIdSoftwarePurchaseEmailPatchRequest, initOverrides?: RequestInit): Promise<ShoppingCartItemSoftwarePurchaseEmailUpdatedDto> {
        const response = await this.apiShoppingCartsShoppingCartItemIdSoftwarePurchaseEmailPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiShoppingCartsTermsOfDeliveriesGetRaw(requestParameters: ApiShoppingCartsTermsOfDeliveriesGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<TermsOfDeliveryDto>>> {
        const queryParameters: any = {};

        if (requestParameters.canUse !== undefined) {
            queryParameters['CanUse'] = requestParameters.canUse;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/ShoppingCarts/TermsOfDeliveries`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TermsOfDeliveryDtoFromJSON));
    }

    /**
     */
    async apiShoppingCartsTermsOfDeliveriesGet(requestParameters: ApiShoppingCartsTermsOfDeliveriesGetRequest, initOverrides?: RequestInit): Promise<Array<TermsOfDeliveryDto>> {
        const response = await this.apiShoppingCartsTermsOfDeliveriesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
